import gql from 'graphql-tag';

import { AlbumFolderEventSettingsFields } from '../../../../../../graphql/fragments/album-folder';
import { MarketingMaterialAssetDetails } from '../../../../../../graphql/fragments/marketing-material-assets';

const getAccountMarketingMaterials = gql`
  query accountMarketingMaterial($id: RecordID!) {
    accountMarketingMaterial(id: $id) {
      id
      type
      pdf_url
      image_url
      account {
        id
        username
        organization_name
        logo_image {
          id
          url
        }
      }
      configuration {
        marketing_material_type
        primary_text_display
        secondary_text_display
        secondary_text_personalized_message
        display_watermark
      }
      album_folder {
        id
        name
        join_code
        is_web_gallery
        onboarding_short_url
        web_app_urls {
          all_photos_access_url
        }
        all_photos_mode
        is_demo
        album_price_mode
        album_type
        album_subtype
        photo_sharing_mode
        joins_enabled
        picture_day_enabled
        face_recognition_disabled
        onboarding_type
        has_charity
        has_video_album
        search_subscription_credits_joins_enabled
        auto_contributor_share_url
        individual_albums
        public_join_code_verification_enabled
        account {
          id
          name
          username
          organization_name
        }
        purchased_event {
          id
          features {
            white_label_marketing_prints_enabled
          }
        }
        purchased_event_addon_types
        price {
          value
        }
        children {
          albums {
            records {
              id
              name
              is_video_album
              purchased_event_addon_types
              created_at
            }
          }
        }
        video_albums {
          records {
            id
          }
        }
        start_date
        marketing_material_assets(slice: { limit: 999 }) {
          total
          records {
            id
            marketing_material_asset {
              ...MarketingMaterialAssetDetails
            }
          }
        }
        event_settings {
          ...AlbumFolderEventSettingsFields
        }
      }
    }
  }
  ${AlbumFolderEventSettingsFields}
  ${MarketingMaterialAssetDetails}
`;

export default getAccountMarketingMaterials;
